var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconRevisionSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 146,
    viewBox: "0 0 200 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_119_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190 20.7915H9.99992C4.47708 20.7915 0 25.2687 0 30.7915V135.792C0 141.314 4.47708 145.791 9.99992 145.791H190C195.523 145.791 200 141.314 200 135.792V30.7915C200 25.2687 195.523 20.7915 190 20.7915Z",
    fill: "#B8E1FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 78.0236C121.546 78.0236 139.012 60.5574 139.012 39.0118C139.012 17.4662 121.546 0 100 0C78.4546 0 60.9883 17.4662 60.9883 39.0118C60.9883 60.5574 78.4546 78.0236 100 78.0236Z",
    fill: "#7CCC2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8496 35.4606L96.3174 49.9284L118.151 28.0952",
    stroke: "white",
    strokeWidth: 6.01965,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.57 92.29H70.4305C68.7736 92.29 67.4304 93.6332 67.4304 95.2901V105.478C67.4304 107.135 68.7736 108.479 70.4305 108.479H129.57C131.227 108.479 132.57 107.135 132.57 105.478V95.2901C132.57 93.6332 131.227 92.29 129.57 92.29Z",
    fill: "#2064A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.369 113.613H47.6309C45.9741 113.613 44.6309 114.956 44.6309 116.613V126.802C44.6309 128.459 45.9741 129.802 47.6309 129.802H152.369C154.026 129.802 155.369 128.459 155.369 126.802V116.613C155.369 114.956 154.026 113.613 152.369 113.613Z",
    fill: "#2064A1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_119_11"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 145.791,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRevisionSuccess);
export default __webpack_public_path__ + "static/media/icon_revision_success.ca97ba1896e3a3131b50ae20d69aafdd.svg";
export { ForwardRef as ReactComponent };